@if (tutorial.active()) {
    @if (tutorial.currentStep(); as step) {
        <div
            class="tut"
            [class.tut--interactive]="interactive()"
        >
            <!-- Dimming layer. When a spotlight rect exists we cut a hole with a big box-shadow ring;
                 otherwise the whole viewport dims for a centered step. -->
            @if (spotlight(); as s) {
                <div
                    class="tut__hole"
                    [style.top.px]="s.top"
                    [style.left.px]="s.left"
                    [style.width.px]="s.width"
                    [style.height.px]="s.height"
                    aria-hidden="true"
                ></div>

                <!-- Interactive tours: lock the dimmed area. This transparent layer captures clicks everywhere
                     except the spotlight rect (punched out via clip-path), so only the highlighted target and the
                     step card are clickable. Real popovers/dialogs are lifted above the tour and stay usable. -->
                @if (interactive()) {
                    <div
                        class="tut__blocker"
                        [style.clip-path]="blockerClip()"
                        (pointerdown)="absorbBlockerEvent($event)"
                        (mousedown)="absorbBlockerEvent($event)"
                        (click)="absorbBlockerEvent($event)"
                        aria-hidden="true"
                    ></div>
                }
            } @else {
                <div
                    class="tut__scrim"
                    aria-hidden="true"
                ></div>
            }

            <!-- #region Step Card -->
            <div
                class="tut__card"
                [class.tut__card--dock-top]="card().dock === 'top'"
                [class.tut__card--dock-bottom]="card().dock === 'bottom'"
                [class.tut__card--center]="card().dock === 'center'"
                [style.top.px]="card().dock || card().bottom != null ? null : card().top"
                [style.bottom.px]="card().dock ? null : card().bottom"
                [style.left.px]="card().dock ? null : card().left"
                role="dialog"
                [attr.aria-modal]="interactive() ? null : 'true'"
                [attr.aria-label]="tutorial.definition()?.title"
                tabindex="-1"
            >
                <div class="tut__head">
                    <h2 class="tut__title">{{ step.title }}</h2>
                </div>

                <p class="tut__body">{{ step.body }}</p>

                <div class="tut__foot">
                    @if (showProgress()) {
                        <span class="tut__progress">{{ progressLabel() }}</span>
                    } @else {
                        <span></span>
                    }
                    <div class="tut__actions">
                        <p-button
                            label="Skip Tutorial"
                            size="small"
                            severity="secondary"
                            [text]="true"
                            data-test="tut-skip"
                            (onClick)="tutorial.exit()"
                        />
                        @if (!tutorial.isFirst()) {
                            <p-button
                                label="Back"
                                size="small"
                                [text]="true"
                                data-test="tut-back"
                                (onClick)="tutorial.back()"
                            />
                        }
                        @if (!step.hideNext) {
                            <p-button
                                [label]="step.nextLabel ?? (tutorial.isLast() ? 'Finish' : 'Next')"
                                size="small"
                                data-test="tut-next"
                                (onClick)="advance()"
                            />
                        }
                    </div>
                </div>
            </div>
            <!-- #endregion -->
        </div>
    }
}
